/**
 * お届け先に関する情報を返却する
 */

var DeliveryArea = DeliveryArea || {};

/**
 * お届け可能な市区町村区を検索
 *
 * @param int storeid
 * @param int prefCode
 *
 * @return Deferred
 */
DeliveryArea.getAvailableDeliveryCities = function (storeid, prefCode) {
	var params = {
		storeId: storeid,
		prefCode: prefCode,
	};

	var defer = $.Deferred();
	$.ajax({
		url: '/service/available-delivery-cities.json',
		method: 'GET',
		data: params,
		cache: true,
		success: defer.resolve,
		error: defer.reject
	});

	return defer.promise();
};
